import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Organization, Department } from '@/api/types/organization.type'

interface OrganizationStoreState {
  currentOrganization: Organization | null
  currentDepartment: Department | null
  setCurrentOrganization: (org: Organization | null) => void
  setCurrentDepartment: (dept: Department | null) => void
}

export const useOrganizationStore = create<OrganizationStoreState>()(
  persist(
    (set) => ({
      currentOrganization: null,
      currentDepartment: null,
      setCurrentOrganization: (org) =>
        set({ currentOrganization: org, currentDepartment: null }),
      setCurrentDepartment: (dept) => set({ currentDepartment: dept }),
    }),
    {
      name: 'organization-store', // localStorage 中的 key
      // 只持久化当前选中的组织和部门信息
      partialize: (state) => ({
        currentOrganization: state.currentOrganization,
        currentDepartment: state.currentDepartment,
      }),
    }
  )
)
